export const ADMIN_ROUTES = {
  app: "/admin",
  new_billing_profile: "new_billing_profile",
}

export const CARRIER_ROUTES = {
  app: "/carrier",
  profile: "profile",
  users: "users",
  new_user: "new_user",
  vehicles: "vehicles",
  new_vehicle: "new_vehicle",
  integrations: "integrations",
  lanes: "lanes",
}
export const MOBILE_APP_ROUTES = {
  app: "/mobile_app",
  profile: "profile",
  users: "users",
  new_user: "new_user",
  vehicles: "vehicles",
  new_vehicle: "new_vehicle",
  integrations: "integrations",
  quote_requests: "quote_requests",
  shipments:"shipments"
}

export const SHIPPING_ROUTES = {
  app: "/shipping",
  profile: "profile",
  new_quote: "new_quote",
  quotes: "quotes",
  quote_requests: "quote_requests",
  quote_offers: "quote_offers",
  new_billing_profile: "new_billing_profile",
}

export const PATHS = {
  services:  "services",
}

export const WEB_ROUTES = {
  app: "/en",
  en_app: "/en",
  en_ca_app: "/en_ca",
  en_us_app: "/en_us",
  fr_app: "/fr",
  fr_ca_app: "/fr_ca",
  fr_us_app: "/fr_us",
  developmentServices: "dev_services/development",
  shippers: "shippers",
  carriers: "carriers",
  about: "about",
  contact: "contact",
  carrierSignup: "carrier_signup",
  shipperSignup: "shipper_signup",
  adminSignup: "admin_signup",
  carrierSignin: "carrier_signin",
  shipperSignin: "shipper_signin",
  adminSignin: "admin_signin",
  shipperForgotPassword: "shipper_forgot_password",
  shipperResetPassword: "shipper_reset_password",
  shipperVerifyEmail: "shipper_verify_email",
  carrierForgotPassword: "carrier_forgot_password",
  carrierResetPassword: "carrier_reset_password",
  carrierVerifyEmail: "carrier_verify_email",
  adminForgotPassword: "admin_forgot_password",
  adminResetPassword: "admin_reset_password",
  adminVerifyEmail: "admin_verify_email",
}


export const SITE_ROUTES = {
  app: "/en",
  en_app: "/en",
  en_ca_app: "/en_ca",
  en_us_app: "/en_us",
  fr_app: "/fr",
  fr_ca_app: "/fr_ca",
  fr_us_app: "/fr_us",
  home: "",
  developmentServices: PATHS.services + "/software_development",
  freightSolutions: "freight",
  freightSolutionsCarrier: "carrier",
  freightSolutionsShipper: "shipper",
  about: "about",
  contact: "contact",
  portefolio: "portfolio",
  resources: "resources",
  services: PATHS.services,
  solutions: "solutions",
  technologies: "technologies",
  carrierSignin: "carrier_signin",
  shipperSignin: "shipper_signin",
  carrierSignup: "carrier_signup",
  shipperSignup: "shipper_signup",
}

export function get_route_path(app, key, locate = 'en_ca') {

  let app_routes = {}

  switch (app) {
    case "site":
      app_routes = SITE_ROUTES;
      break;
    case "web":
      app_routes = WEB_ROUTES;
      break;
    case "carrier":
      app_routes = CARRIER_ROUTES;
      break;
    case "shipping":
      app_routes = SHIPPING_ROUTES;
      break;
    case "mobile_app":
      app_routes = MOBILE_APP_ROUTES;
      break;
    case "admin":
      app_routes = ADMIN_ROUTES;
      break;
    default:
      app_routes = SITE_ROUTES;
      break;
  }

  // Resolve the base path for the given locale.
  // Tries `${locate}_app` first, then falls back to the default `app`.
  const localeAppKey = `${locate}_app`;
  const app_path = (localeAppKey in app_routes)
    ? app_routes[localeAppKey]
    : app_routes['app'];

  let key_path = '';
  if (key === 'app') {
    key_path = '';
  } else {
    key_path = (key in app_routes) ? app_routes[key] : '';
  }

  return `${app_path}/${key_path}`;
}